import React from 'react';
import Spinkit from 'react-spinkit';

const Spinner = props => (
  <Spinkit
    spinnerName='three-bounce'
    overrideSpinnerClassName='spinner'/>
)

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js